export default {
  SUPPLEMENTAL_MIN_FIELD: "bd397e48-1d5f-4fa9-9c28-eb22d9a90c9d",
  ADDITIONAL_SUPP_RISK_SPREAD: "9206630c-d0a1-4b06-b988-5d9c585732b6",
  FIRST_SUPP_RISK_SPREAD: "8881e3fd-7e03-41d0-8439-2fe10bf0a829",
  AMORTIZATION_TERM: "226d41b5-3899-478b-b8ce-ce74d0e2d3a3",
  FLOATING_RATE_DEFAULT_INDEX: "c19f63f9-a000-11ea-9935-2c4d543da462",
  FIXED_RATE_DEFAULT_INDEX: "cce5c7f6-a000-11ea-9935-2c4d543da462"
};
